<template>
  <div class="my-integral-record">
    <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
      :immediate-check="false"
      class="list-container"
    >
      <div v-for="(item,index) in yearObj" :key="index" class="item-container">
        <div class="year-title">{{index}}</div>
        <div class="year-content">
            <div class="integral-item" v-for="(child,i) in item.children" :key="child.pkid + '-' + i" @click="itemClick(child)" >
                <div class="integral-item-flex" v-if="pageType == 'integral-record'">
                    <template v-if="child.transactionMethod == 2">
                        <div>订单号：{{child.pkid}}</div>
                        <div class="item-time">
                            <span class="item-span">{{child.payTime}}</span>
                            <span class="item-span">{{child.chargeElect}}度</span>
                            <span class="item-span">{{child.totalAmount}}元</span>
                        </div>
                    </template>
                    <template v-else>
                        <div>{{child.transactionMethodDesc}}</div>
                        <div class="item-time">
                            <span class="item-span">{{child.createTime}}</span>
                        </div>
                    </template>
                </div>
                <div class="integral-item-flex" v-else>
                    <div>兑换订单号：{{child.pkid}}</div>
                    <div class="item-time">
                        <span class="item-span">{{child.payTime || '--'}}</span>
                        <span class="item-span">{{child.vipName || '--'}}</span>
                    </div>
                </div>
                <div class="integral-num v-center" :class="child.transactionPoints < 0 ? 'exchange':''">
                    {{child.transactionPoints}}
                    <i class="right-arrow"></i>
                </div>
            </div>
        </div>
    </div>
    <pi-no-list-data v-if="yearIntegral.length == 0" :list="yearIntegral" text="暂无记录">
        <image src="../../../../picture/no-data-icon/invoice.png" class="no-list-icon" />
    </pi-no-list-data>
    </van-list>
  </div>
</template>
<script>
import { List } from "vant";
import noListData from "@/components/pi-no-list-data/pi-no-list-data.vue";
import {
  getPointsAddList,
  getPointsExchangeList
} from "@/common/api";

export default {
  name: "pi-record-tab",
  components: {
    [List.name]: List,
    [noListData.name]: noListData,
  },
  data() {
    return {
      yearIntegral: [],
      loading: false,
      finished: false,
      form: {
        globalPageIndex: 0,
        globalPageSize: 20,
      },
      year: '',
      yearObj: {
        
      },
    }
  },
  props: {
    pageType: {
      type: String,
      default: 'integral-record'
    }
  },
  mounted() {

    this.onLoad();
  },
  methods: {
    itemClick(item){
      this.$common.save('integral-record-details',item);
      this.$router.push('/my-integral-record/details?pageType='+this.pageType)
    },
    onLoad () {
      this.form.globalPageIndex += 1;
      if(this.pageType == 'integral-record'){
        this.getPointsAddList();
      }else{
        this.getPointsExchangeList();
      }
    },
    getPointsAddList(){
      this.loading = true;
      getPointsAddList(this.form).then((ret) => {
        if (ret.status === this.$config.ajaxStatus) {
          this.yearIntegral = this.yearIntegral.concat(ret.data);
          this.forData();
          this.finished = ret.data.length < this.form.globalPageSize;
        }else{
          this.$toast(ret.msg);
        }
        this.loading = false;
      })
    },
    getPointsExchangeList(){
      this.loading = true;
      getPointsExchangeList(this.form).then((ret) => {
        if (ret.status === this.$config.ajaxStatus) {
          this.yearIntegral = this.yearIntegral.concat(ret.data);
          this.forData();
          this.finished = ret.data.length < this.form.globalPageSize;
        }else{
          this.$toast(ret.msg);
        }
        this.loading = false;
      })
    },
    forData(){
      this.yearIntegral.map(item=>{
        if(item.createTime){
          let timeArr = item.createTime.split('-');
          let time = timeArr[0] + '-' + timeArr[1];
          if(!this.yearObj[time]){
            this.yearObj[time] = {children: []};
          }
          this.yearObj[time].children.push(item);
        }
      })
    }
  }
}
</script>
<style lang="less">
.my-integral-record{

  .year-title{
    padding: 0.2rem 0;
    color: #000000;
    font-size: 0.28rem;
    line-height: 0.4rem;
  }
  .item-container{
     padding: 0 0.2rem ;
  }
  .year-content{
    background-color: #fff;
    border-radius: 0.12rem;
    padding: 0 0.2rem;
    .integral-item{
      border-top: 1px solid #eee;
      font-size: 0.24rem;
      line-height: 0.33rem;
      display: flex;
      padding: 0.2rem 0;
      color: #999999;
      .integral-item-flex{
        flex: 1;
      }
      .item-time{
        margin-top: 0.2rem;
        .item-span{
          margin-right: 0.4rem;
        }
      }
      .integral-num{
        font-size: 0.36rem;
        line-height: 0.5rem;
        color: #14CC80;
      }
      .integral-num.exchange{
        color: #F67731;
      }
    }
    .integral-item:first-child{
      border:none
    }
  }
}
</style>